import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

type C50TopStatisticsItemFields = {
  TopStatistic?: Field<string>;
  SupportCopy?: RichTextField;
};

export type C50TopStatisticsItemProps = RenderingProps<
  C50TopStatisticsItemFields,
  DynamicPlaceholderParams & TranslationOptionsParams & AnchorTargetParams
>;
